export const countryFlags = {
  American: "🇺🇸",
  British: "🇬🇧",
  Cambodian: "🇰🇭",
  Canadian: "🇨🇦",
  Chinese: "🇨🇳",
  Croatian: "🇭🇷",
  Dutch: "🇳🇱",
  Egyptian: "🇪🇬",
  Filipino: "🇵🇭",
  French: "🇫🇷",
  Greek: "🇬🇷",
  Indian: "🇮🇳",
  Irish: "🇮🇪",
  Italian: "🇮🇹",
  Jamaican: "🇯🇲",
  Japanese: "🇯🇵",
  Kenyan: "🇰🇪",
  Korean: "🇰🇷",
  Malaysian: "🇲🇾",
  Mexican: "🇲🇽",
  Moroccan: "🇲🇦",
  Polish: "🇵🇱",
  Portuguese: "🇵🇹",
  Russian: "🇷🇺",
  Spanish: "🇪🇸",
  Tunisian: "🇹🇳",
  Turkish: "🇹🇷",
  Ukrainian: "🇺🇦",
  Vietnamese: "🇻🇳",
  Brazilian: "🇧🇷",
  Argentinian: "🇦🇷",
};

// Regroupement des pays par grandes régions
// Utilisé pour filtrer les pays par continent (Asie, Europe, Afrique, etc.)
export const countryRegions = {
  American: "Americas",
  Canadian: "Americas",
  Mexican: "Americas",
  Brazilian: "Americas",
  Argentinian: "Americas",
  Jamaican: "Americas",

  British: "Europe",
  French: "Europe",
  Irish: "Europe",
  Italian: "Europe",
  Spanish: "Europe",
  Dutch: "Europe",
  Greek: "Europe",
  Croatian: "Europe",
  Polish: "Europe",
  Portuguese: "Europe",
  Russian: "Europe",
  Ukrainian: "Europe",
  Turkish: "Europe",

  Egyptian: "Africa",
  Moroccan: "Africa",
  Tunisian: "Africa",
  Kenyan: "Africa",

  Chinese: "Asia",
  Cambodian: "Asia",
  Filipino: "Asia",
  Indian: "Asia",
  Japanese: "Asia",
  Korean: "Asia",
  Malaysian: "Asia",
  Vietnamese: "Asia",
};

// Cuisines spéciales avec mots-clés de recherche
export const specialCuisines = [
  {
    name: "Cambodian",
    flag: "🇰🇭",
    // Mots-clés plus spécifiques à la cuisine khmère
    keywords: [
      "curry",
      "soup",
      "noodle",
      "lime",
      "ginger",
      "fish",
      "coconut milk",
      "rice noodle",
    ],
    // Recettes manuelles traditionnelles khmères
    customRecipes: [
      {
        idMeal: "khmer1",
        strMeal: "Amok Trey (Poisson au Curry)",
        strMealThumb:
          "https://images.unsplash.com/photo-1455619452474-d2be8b1e70cd?w=400",
        strArea: "Cambodian",
        strCategory: "Seafood",
        description:
          "Plat national cambodgien - Poisson cuit à la vapeur dans une sauce au curry et lait de coco",
        ingredients: [
          { name: "Poisson blanc (filet)", measure: "500g" },
          { name: "Lait de coco", measure: "400ml" },
          { name: "Pâte kroeung", measure: "3 c. à soupe" },
          { name: "Pâte de curry rouge", measure: "2 c. à soupe" },
          { name: "Œufs", measure: "2" },
          { name: "Sauce de poisson", measure: "2 c. à soupe" },
          { name: "Sucre de palme", measure: "1 c. à thé" },
          { name: "Feuilles de bananier", measure: "4" },
          { name: "Basilic thaï", measure: "1 poignée" },
          { name: "Piment rouge", measure: "1 (émincé)" },
        ],
        instructions:
          "1. Mélanger la pâte kroeung et curry avec le lait de coco\n2. Ajouter les œufs battus, sauce de poisson et sucre\n3. Couper le poisson en morceaux et mélanger à la sauce\n4. Tapisser des bols avec feuilles de bananier\n5. Verser le mélange et garnir de basilic\n6. Cuire à la vapeur 20-25 minutes\n7. Garnir de piment et basilic frais",
      },
      {
        idMeal: "khmer2",
        strMeal: "Kuy Teav (Soupe de Nouilles)",
        strMealThumb:
          "https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=400",
        strArea: "Cambodian",
        strCategory: "Soup",
        description:
          "Soupe traditionnelle khmère avec nouilles de riz, porc et crevettes",
        ingredients: [
          { name: "Nouilles de riz fraîches", measure: "300g" },
          { name: "Bouillon de porc", measure: "1.5L" },
          { name: "Porc haché", measure: "200g" },
          { name: "Crevettes", measure: "150g" },
          { name: "Germes de soja", measure: "100g" },
          { name: "Ciboulette", measure: "1 bouquet" },
          { name: "Ail frit", measure: "3 c. à soupe" },
          { name: "Sauce de poisson", measure: "3 c. à soupe" },
          { name: "Citron vert", measure: "2" },
          { name: "Piment frais", measure: "2-3" },
        ],
        instructions:
          "1. Faire bouillir le bouillon de porc avec gingembre\n2. Cuire le porc haché dans le bouillon\n3. Ajouter les crevettes et cuire 3 minutes\n4. Faire tremper les nouilles dans l'eau chaude\n5. Dans un bol, mettre les nouilles\n6. Verser le bouillon chaud avec viande\n7. Garnir de germes de soja, ciboulette et ail frit\n8. Servir avec citron vert et piments",
      },
      {
        idMeal: "khmer3",
        strMeal: "Lok Lak (Bœuf sauté)",
        strMealThumb:
          "https://images.unsplash.com/photo-1603133872878-684f208fb84b?w=400",
        strArea: "Cambodian",
        strCategory: "Beef",
        description:
          "Bœuf mariné sauté servi avec sauce au citron vert et poivre",
        ingredients: [
          { name: "Bœuf (sirloin)", measure: "600g" },
          { name: "Sauce soja", measure: "3 c. à soupe" },
          { name: "Sauce d'huître", measure: "2 c. à soupe" },
          { name: "Ail haché", measure: "4 gousses" },
          { name: "Sucre", measure: "1 c. à soupe" },
          { name: "Poivre noir", measure: "1 c. à thé" },
          { name: "Citron vert", measure: "3" },
          { name: "Poivre de Kampot", measure: "2 c. à thé" },
          { name: "Laitue", measure: "1 tête" },
          { name: "Tomates", measure: "2" },
          { name: "Oignons", measure: "1" },
          { name: "Riz blanc", measure: "Pour servir" },
        ],
        instructions:
          "1. Mariner le bœuf avec sauce soja, huître, ail et sucre (30 min)\n2. Préparer la sauce : jus de citron vert + poivre de Kampot + sel\n3. Faire chauffer un wok à feu vif\n4. Saisir le bœuf 2-3 minutes de chaque côté\n5. Dresser sur un lit de laitue et tomates\n6. Servir avec la sauce citron-poivre et riz blanc\n7. Ajouter des oignons frits pour la garniture",
      },
      {
        idMeal: "khmer4",
        strMeal: "Num Banh Chok (Nouilles Khmères)",
        strMealThumb:
          "https://images.unsplash.com/photo-1555126634-323283e090fa?w=400",
        strArea: "Cambodian",
        strCategory: "Vegetarian",
        description:
          "Nouilles de riz fraîches avec curry de poisson ou coco végétarien",
        ingredients: [
          { name: "Nouilles de riz fraîches", measure: "400g" },
          { name: "Lait de coco", measure: "400ml" },
          { name: "Pâte de curry vert", measure: "3 c. à soupe" },
          { name: "Citronnelle", measure: "2 tiges" },
          { name: "Concombre", measure: "1 (tranché)" },
          { name: "Haricots longs", measure: "200g" },
          { name: "Germes de soja", measure: "150g" },
          { name: "Feuilles de basilic", measure: "1 bouquet" },
          { name: "Menthe fraîche", measure: "1 bouquet" },
          { name: "Fleurs de bananier", measure: "100g (optionnel)" },
        ],
        instructions:
          "1. Préparer le curry : faire chauffer lait de coco avec pâte de curry\n2. Ajouter citronnelle hachée et mijoter 15 min\n3. Blanchir les haricots longs 2 minutes\n4. Rincer les nouilles de riz à l'eau froide\n5. Dans un bol, disposer les nouilles\n6. Verser le curry de coco par-dessus\n7. Garnir de légumes frais, herbes et germes\n8. Servir frais avec citron vert",
      },
      {
        idMeal: "khmer5",
        strMeal: "Samlor Kako (Soupe Verte)",
        strMealThumb:
          "https://images.unsplash.com/photo-1547592166-23ac45744acd?w=400",
        strArea: "Cambodian",
        strCategory: "Soup",
        description:
          "Soupe verte traditionnelle aux légumes, kroeung et citronnelle",
      },
      {
        idMeal: "khmer6",
        strMeal: "Bai Sach Chrouk (Riz au Porc)",
        strMealThumb:
          "https://images.unsplash.com/photo-1512058564366-18510be2db19?w=400",
        strArea: "Cambodian",
        strCategory: "Pork",
        description:
          "Petit-déjeuner typique : porc grillé sur riz avec légumes marinés",
        ingredients: [
          { name: "Porc (tranches fines)", measure: "500g" },
          { name: "Lait de coco", measure: "200ml" },
          { name: "Ail haché", measure: "5 gousses" },
          { name: "Sauce soja", measure: "3 c. à soupe" },
          { name: "Sucre de palme", measure: "2 c. à soupe" },
          { name: "Sauce de poisson", measure: "1 c. à soupe" },
          { name: "Riz jasmin", measure: "400g (cuit)" },
          { name: "Concombre", measure: "1 (tranché)" },
          { name: "Radis mariné", measure: "100g" },
          { name: "Œufs", measure: "4 (optionnel)" },
        ],
        instructions:
          "1. Mariner le porc : lait de coco, ail, sauce soja, sucre (2h minimum)\n2. Faire griller le porc sur charbon ou grill (5-7 min chaque côté)\n3. Cuire le riz jasmin parfumé\n4. Préparer les accompagnements : concombre, radis marinés\n5. Dresser le riz dans une assiette\n6. Disposer le porc grillé par-dessus\n7. Ajouter légumes marinés et frais\n8. Optionnel : servir avec un œuf au plat",
      },
      {
        idMeal: "khmer7",
        strMeal: "Nom Banh Chok (Nouilles au Curry)",
        strMealThumb:
          "https://images.unsplash.com/photo-1617093727343-374698b1b08d?w=400",
        strArea: "Cambodian",
        strCategory: "Noodles",
        description:
          "Nouilles de riz avec curry de poisson fermenté, légumes frais et herbes",
      },
      {
        idMeal: "khmer8",
        strMeal: "Lap Khmer (Salade de Bœuf)",
        strMealThumb:
          "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400",
        strArea: "Cambodian",
        strCategory: "Salad",
        description:
          "Salade de bœuf cru mariné au citron vert, menthe et basilic",
      },
      {
        idMeal: "khmer9",
        strMeal: "Samlor Machu Yuon (Soupe Aigre)",
        strMealThumb:
          "https://images.unsplash.com/photo-1547592166-23ac45744acd?w=400",
        strArea: "Cambodian",
        strCategory: "Soup",
        description:
          "Soupe aigre-douce vietnamo-cambodgienne avec ananas et tomates",
      },
      {
        idMeal: "khmer10",
        strMeal: "Cha Kroeung (Poulet Lemongrass)",
        strMealThumb:
          "https://images.unsplash.com/photo-1598103442097-8b74394b95c6?w=400",
        strArea: "Cambodian",
        strCategory: "Chicken",
        description: "Poulet sauté avec pâte kroeung, citronnelle et piments",
      },
      {
        idMeal: "khmer11",
        strMeal: "Prahok Ktis (Pâte de Poisson)",
        strMealThumb:
          "https://images.unsplash.com/photo-1563379091339-03b847259519?w=400",
        strArea: "Cambodian",
        strCategory: "Seafood",
        description:
          "Pâte de poisson fermentée avec porc haché et lait de coco",
      },
      {
        idMeal: "khmer12",
        strMeal: "Samlor Korko (Soupe Khmère)",
        strMealThumb:
          "https://images.unsplash.com/photo-1547592166-23ac45744acd?w=400",
        strArea: "Cambodian",
        strCategory: "Soup",
        description: "Soupe traditionnelle avec pâte de riz pilée et légumes",
      },
      {
        idMeal: "khmer13",
        strMeal: "Bok L'hong (Salade de Papaye)",
        strMealThumb:
          "https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?w=400",
        strArea: "Cambodian",
        strCategory: "Salad",
        description:
          "Salade de papaye verte avec tomates, arachides et crevettes séchées",
        ingredients: [
          { name: "Papaye verte", measure: "1 moyenne (râpée)" },
          { name: "Tomates cerises", measure: "150g" },
          { name: "Haricots verts", measure: "100g" },
          { name: "Arachides grillées", measure: "50g" },
          { name: "Crevettes séchées", measure: "30g" },
          { name: "Ail", measure: "3 gousses" },
          { name: "Piments frais", measure: "3-5" },
          { name: "Sauce de poisson", measure: "3 c. à soupe" },
          { name: "Jus de citron vert", measure: "3 c. à soupe" },
          { name: "Sucre de palme", measure: "2 c. à soupe" },
        ],
        instructions:
          "1. Piler l'ail et piments dans un mortier\n2. Ajouter haricots verts et piler légèrement\n3. Ajouter papaye râpée et piler doucement\n4. Ajouter tomates et mélanger\n5. Assaisonner : sauce de poisson, citron vert, sucre\n6. Ajouter crevettes séchées et arachides\n7. Bien mélanger tous les ingrédients\n8. Servir frais avec riz gluant",
      },
      {
        idMeal: "khmer14",
        strMeal: "Sngor Chrouk (Soupe de Porc)",
        strMealThumb:
          "https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=400",
        strArea: "Cambodian",
        strCategory: "Soup",
        description: "Soupe de côtes de porc avec gingembre et citronnelle",
      },
      {
        idMeal: "khmer15",
        strMeal: "Trey Chien Chou Ayme (Poisson Frit)",
        strMealThumb:
          "https://images.unsplash.com/photo-1519708227418-c8fd9a32b7a2?w=400",
        strArea: "Cambodian",
        strCategory: "Seafood",
        description: "Poisson frit sauce aigre-douce avec mangue verte",
      },
      {
        idMeal: "khmer16",
        strMeal: "Pleah Sach Ko (Salade de Bœuf Grillé)",
        strMealThumb:
          "https://images.unsplash.com/photo-1546833999-b9f581a1996d?w=400",
        strArea: "Cambodian",
        strCategory: "Beef",
        description: "Bœuf grillé en salade avec concombre, menthe et basilic",
      },
      {
        idMeal: "khmer17",
        strMeal: "Kdam Chaa (Crabe au Poivre)",
        strMealThumb:
          "https://images.unsplash.com/photo-1626200419199-391ae4be7a41?w=400",
        strArea: "Cambodian",
        strCategory: "Seafood",
        description: "Crabe de Kep sauté au poivre vert de Kampot",
        ingredients: [
          { name: "Crabes frais de Kep", measure: "2 gros" },
          { name: "Poivre vert de Kampot", measure: "4 c. à soupe" },
          { name: "Ail haché", measure: "6 gousses" },
          { name: "Échalotes émincées", measure: "4" },
          { name: "Sauce d'huître", measure: "2 c. à soupe" },
          { name: "Sauce de poisson", measure: "1 c. à soupe" },
          { name: "Sucre", measure: "1 c. à thé" },
          { name: "Huile végétale", measure: "4 c. à soupe" },
          { name: "Ciboulette fraîche", measure: "1 bouquet" },
          { name: "Piment rouge", measure: "2 (optionnel)" },
        ],
        instructions:
          "1. Nettoyer et découper les crabes en morceaux\n2. Écraser légèrement le poivre vert de Kampot frais\n3. Chauffer l'huile dans un grand wok à feu vif\n4. Faire revenir ail et échalotes jusqu'à parfumés (1 min)\n5. Ajouter les morceaux de crabe et sauter 3-4 minutes\n6. Ajouter le poivre vert, sauce d'huître et sauce de poisson\n7. Sauter vigoureusement à feu vif pendant 5-7 minutes\n8. Garnir de ciboulette fraîche et servir immédiatement avec riz blanc",
      },
      {
        idMeal: "khmer18",
        strMeal: "Somlah Machou Ktih (Soupe de Bambou)",
        strMealThumb:
          "https://images.unsplash.com/photo-1547592166-23ac45744acd?w=400",
        strArea: "Cambodian",
        strCategory: "Soup",
        description: "Soupe aigre aux pousses de bambou et porc",
      },
      {
        idMeal: "khmer19",
        strMeal: "Char Kroeung Sach Moan (Poulet Rouge)",
        strMealThumb:
          "https://images.unsplash.com/photo-1598103442097-8b74394b95c6?w=400",
        strArea: "Cambodian",
        strCategory: "Chicken",
        description: "Poulet mijoté dans kroeung rouge et lait de coco",
      },
      {
        idMeal: "khmer20",
        strMeal: "Num Pang Pâté (Sandwich Khmer)",
        strMealThumb:
          "https://images.unsplash.com/photo-1509722747041-616f39b57569?w=400",
        strArea: "Cambodian",
        strCategory: "Street Food",
        description:
          "Sandwich baguette française avec pâté, légumes marinés et coriandre",
        ingredients: [
          { name: "Baguette française", measure: "4 petites" },
          { name: "Pâté de porc", measure: "200g" },
          { name: "Saucisse vietnamienne", measure: "4" },
          { name: "Carotte marinée", measure: "150g" },
          { name: "Radis blanc mariné", measure: "150g" },
          { name: "Concombre", measure: "1 (tranché)" },
          { name: "Coriandre fraîche", measure: "1 gros bouquet" },
          { name: "Sauce soja", measure: "2 c. à soupe" },
          { name: "Sauce pimentée", measure: "Au goût" },
          { name: "Mayonnaise", measure: "4 c. à soupe" },
        ],
        instructions:
          "1. Couper les baguettes en deux horizontalement\n2. Tartiner de mayonnaise les deux côtés\n3. Étaler une couche généreuse de pâté\n4. Ajouter les saucisses grillées tranchées\n5. Garnir de carottes et radis marinés\n6. Ajouter concombre frais tranché\n7. Mettre beaucoup de coriandre fraîche\n8. Arroser de sauce soja et piment selon goût\n9. Refermer et déguster comme street food!",
      },
    ],
  },
  {
    name: "Korean",
    flag: "🇰🇷",
    keywords: ["kimchi", "bibimbap", "bulgogi", "korean"],
    customRecipes: [
      {
        idMeal: "korean1",
        strMeal: "Bibimbap (Bol de Riz Mixte)",
        strMealThumb:
          "https://images.unsplash.com/photo-1553163147-622ab57be1c7?w=400",
        strArea: "Korean",
        strCategory: "Rice",
        description: "Bol de riz avec légumes sautés, viande et œuf au plat",
        ingredients: [
          { name: "Riz blanc cuit", measure: "4 bols" },
          { name: "Bœuf émincé", measure: "300g" },
          { name: "Épinards", measure: "200g" },
          { name: "Carottes", measure: "2 (julienne)" },
          { name: "Champignons shiitake", measure: "150g" },
          { name: "Courgettes", measure: "1 (julienne)" },
          { name: "Germes de soja", measure: "150g" },
          { name: "Œufs", measure: "4" },
          {
            name: "Pâte de piment coréen (Gochujang)",
            measure: "4 c. à soupe",
          },
          { name: "Huile de sésame", measure: "3 c. à soupe" },
          { name: "Sauce soja", measure: "3 c. à soupe" },
          { name: "Ail haché", measure: "3 gousses" },
          { name: "Graines de sésame", measure: "2 c. à soupe" },
        ],
        instructions:
          "1. Mariner le bœuf avec sauce soja, ail et huile de sésame\n2. Faire sauter chaque légume séparément avec un peu d'huile\n3. Faire revenir le bœuf mariné jusqu'à cuisson complète\n4. Faire des œufs au plat (jaune coulant)\n5. Dans 4 bols, mettre le riz chaud\n6. Disposer les légumes et viande en sections autour du riz\n7. Placer l'œuf au centre\n8. Servir avec gochujang et huile de sésame\n9. Bien mélanger avant de manger!",
      },
      {
        idMeal: "korean2",
        strMeal: "Bulgogi (Bœuf Mariné Grillé)",
        strMealThumb:
          "https://images.unsplash.com/photo-1590301157890-4810ed352733?w=400",
        strArea: "Korean",
        strCategory: "Beef",
        description: "Bœuf finement tranché mariné dans une sauce sucrée-salée",
        ingredients: [
          { name: "Bœuf (ribeye ou sirloin)", measure: "700g" },
          { name: "Sauce soja", measure: "100ml" },
          { name: "Sucre brun", measure: "3 c. à soupe" },
          { name: "Huile de sésame", measure: "2 c. à soupe" },
          { name: "Ail haché", measure: "6 gousses" },
          { name: "Poire asiatique râpée", measure: "1/2" },
          { name: "Gingembre frais râpé", measure: "1 c. à soupe" },
          { name: "Oignon", measure: "1 (tranché)" },
          { name: "Oignons verts", measure: "4 (coupés)" },
          { name: "Graines de sésame", measure: "2 c. à soupe" },
          { name: "Poivre noir", measure: "1 c. à thé" },
        ],
        instructions:
          "1. Trancher finement le bœuf contre le grain\n2. Préparer la marinade : sauce soja, sucre, huile de sésame, ail\n3. Ajouter poire râpée et gingembre (attendrisseurs naturels)\n4. Mariner le bœuf minimum 2h (mieux : une nuit)\n5. Faire chauffer un grill ou une poêle à feu vif\n6. Griller le bœuf avec les oignons 2-3 minutes de chaque côté\n7. Ajouter oignons verts en fin de cuisson\n8. Garnir de graines de sésame\n9. Servir avec riz blanc et kimchi",
      },
      {
        idMeal: "korean3",
        strMeal: "Kimchi Jjigae (Ragoût de Kimchi)",
        strMealThumb:
          "https://images.unsplash.com/photo-1582169296194-e4d644c48063?w=400",
        strArea: "Korean",
        strCategory: "Soup",
        description: "Ragoût épicé au kimchi et porc",
        ingredients: [
          { name: "Kimchi vieilli", measure: "400g" },
          { name: "Porc en tranches", measure: "300g" },
          { name: "Tofu ferme", measure: "200g" },
          { name: "Oignon", measure: "1 (tranché)" },
          { name: "Oignons verts", measure: "3" },
          { name: "Ail haché", measure: "4 gousses" },
          {
            name: "Pâte de piment coréen (Gochugaru)",
            measure: "2 c. à soupe",
          },
          { name: "Sauce soja", measure: "2 c. à soupe" },
          { name: "Huile de sésame", measure: "1 c. à soupe" },
          { name: "Bouillon de porc", measure: "600ml" },
          { name: "Sucre", measure: "1 c. à thé" },
        ],
        instructions:
          "1. Faire revenir le porc dans une casserole avec huile\n2. Ajouter l'ail et oignons, faire sauter 2 minutes\n3. Ajouter le kimchi et faire revenir 5 minutes\n4. Verser le bouillon et porter à ébullition\n5. Ajouter pâte de piment, sauce soja et sucre\n6. Mijoter 20 minutes à feu moyen\n7. Ajouter le tofu coupé en cubes\n8. Cuire encore 10 minutes\n9. Garnir d'oignons verts et huile de sésame\n10. Servir bouillant avec riz blanc",
      },
      {
        idMeal: "korean4",
        strMeal: "Japchae (Nouilles Sautées)",
        strMealThumb:
          "https://images.unsplash.com/photo-1512058564366-18510be2db19?w=400",
        strArea: "Korean",
        strCategory: "Noodles",
        description: "Nouilles de patate douce sautées avec légumes colorés",
        ingredients: [
          { name: "Nouilles de patate douce", measure: "300g" },
          { name: "Bœuf émincé", measure: "200g" },
          { name: "Épinards", measure: "150g" },
          { name: "Carottes", measure: "1 (julienne)" },
          { name: "Champignons shiitake", measure: "100g" },
          { name: "Oignon", measure: "1 (émincé)" },
          { name: "Poivron rouge", measure: "1" },
          { name: "Sauce soja", measure: "5 c. à soupe" },
          { name: "Sucre", measure: "2 c. à soupe" },
          { name: "Huile de sésame", measure: "3 c. à soupe" },
          { name: "Ail haché", measure: "3 gousses" },
          { name: "Graines de sésame", measure: "2 c. à soupe" },
        ],
        instructions:
          "1. Faire cuire les nouilles selon instructions (6-7 min)\n2. Rincer à l'eau froide et égoutter\n3. Faire sauter le bœuf avec ail jusqu'à cuit\n4. Faire blanchir les épinards 1 minute\n5. Faire sauter séparément chaque légume\n6. Dans un grand bol, mélanger nouilles avec sauce soja, sucre, huile sésame\n7. Ajouter tous les légumes et viande\n8. Bien mélanger le tout\n9. Garnir de graines de sésame\n10. Servir chaud ou à température ambiante",
      },
      {
        idMeal: "korean5",
        strMeal: "Tteokbokki (Gâteaux de Riz Épicés)",
        strMealThumb:
          "https://images.unsplash.com/photo-1534422298391-e4f8c172dddb?w=400",
        strArea: "Korean",
        strCategory: "Street Food",
        description: "Gâteaux de riz cylindriques en sauce épicée sucrée",
        ingredients: [
          { name: "Gâteaux de riz coréens", measure: "500g" },
          {
            name: "Pâte de piment coréen (Gochujang)",
            measure: "3 c. à soupe",
          },
          { name: "Flocons de piment (Gochugaru)", measure: "1 c. à soupe" },
          { name: "Sucre", measure: "2 c. à soupe" },
          { name: "Sauce soja", measure: "1 c. à soupe" },
          { name: "Ail haché", measure: "3 gousses" },
          { name: "Oignons verts", measure: "4" },
          { name: "Gâteaux de poisson", measure: "150g (optionnel)" },
          { name: "Œufs durs", measure: "2" },
          { name: "Eau ou bouillon", measure: "400ml" },
        ],
        instructions:
          "1. Faire tremper les gâteaux de riz 20 min si secs\n2. Dans une casserole, mélanger eau, gochujang, gochugaru, sucre\n3. Porter à ébullition puis ajouter ail et sauce soja\n4. Ajouter les gâteaux de riz\n5. Cuire 10-12 minutes en remuant jusqu'à sauce épaisse\n6. Ajouter gâteaux de poisson si désiré\n7. Ajouter oignons verts en fin de cuisson\n8. Garnir d'œufs durs coupés\n9. Servir chaud comme snack ou plat principal",
      },
      {
        idMeal: "korean6",
        strMeal: "Samgyeopsal (Porc Grillé)",
        strMealThumb:
          "https://images.unsplash.com/photo-1602030638412-bb8be5c2c544?w=400",
        strArea: "Korean",
        strCategory: "Pork",
        description: "Tranches de poitrine de porc grillées à table",
        ingredients: [
          { name: "Poitrine de porc", measure: "800g (tranches épaisses)" },
          { name: "Laitue feuilles", measure: "1 tête" },
          { name: "Feuilles de périlla", measure: "20 feuilles" },
          { name: "Kimchi", measure: "200g" },
          { name: "Ail tranché", measure: "1 tête" },
          { name: "Piments verts", measure: "4-5" },
          { name: "Sauce ssamjang", measure: "150g" },
          { name: "Huile de sésame", measure: "Pour badigeonner" },
          { name: "Sel marin", measure: "Au goût" },
          { name: "Poivre noir", measure: "Au goût" },
        ],
        instructions:
          "1. Préchauffer le grill ou la poêle\n2. Griller les tranches de porc sans huile\n3. Cuire 3-4 minutes de chaque côté\n4. Badigeonner d'huile de sésame en fin de cuisson\n5. Assaisonner de sel et poivre\n6. Préparer les accompagnements : laitue, périlla, kimchi\n7. Faire griller l'ail et piments à côté\n8. Prendre une feuille de laitue\n9. Mettre porc + ail + kimchi + ssamjang\n10. Enrouler et déguster en une bouchée (ssam)!",
      },
      {
        idMeal: "korean7",
        strMeal: "Kimchi (Chou Fermenté Épicé)",
        strMealThumb:
          "https://images.unsplash.com/photo-1606677271160-b1e091abcb27?w=400",
        strArea: "Korean",
        strCategory: "Side Dish",
        description: "Le fameux chou fermenté coréen épicé",
        ingredients: [
          { name: "Chou napa", measure: "1 gros" },
          { name: "Gros sel", measure: "1/2 tasse" },
          { name: "Flocons de piment (Gochugaru)", measure: "1/2 tasse" },
          { name: "Sauce de poisson", measure: "3 c. à soupe" },
          { name: "Pâte de crevettes", measure: "1 c. à soupe" },
          { name: "Sucre", measure: "1 c. à soupe" },
          { name: "Ail haché", measure: "8 gousses" },
          { name: "Gingembre râpé", measure: "2 c. à soupe" },
          { name: "Radis blanc", measure: "200g (julienne)" },
          { name: "Oignons verts", measure: "5" },
        ],
        instructions:
          "1. Couper le chou en quartiers et saler généreusement\n2. Laisser dégorger 4-6 heures en retournant\n3. Rincer abondamment et égoutter\n4. Préparer la pâte : gochugaru, sauce poisson, crevettes, sucre\n5. Ajouter ail, gingembre, radis et oignons verts\n6. Enrober chaque feuille de chou avec la pâte\n7. Placer dans un bocal hermétique\n8. Laisser fermenter à température ambiante 1-2 jours\n9. Puis réfrigérer et consommer pendant 2-3 mois",
      },
      {
        idMeal: "korean8",
        strMeal: "Sundubu Jjigae (Ragoût Tofu)",
        strMealThumb:
          "https://images.unsplash.com/photo-1547592180-85f173990554?w=400",
        strArea: "Korean",
        strCategory: "Soup",
        description: "Ragoût épicé au tofu soyeux et fruits de mer",
        ingredients: [
          { name: "Tofu soyeux", measure: "400g" },
          { name: "Crevettes", measure: "150g" },
          { name: "Palourdes", measure: "200g" },
          { name: "Œuf", measure: "1" },
          { name: "Pâte de piment (Gochugaru)", measure: "2 c. à soupe" },
          { name: "Sauce soja", measure: "2 c. à soupe" },
          { name: "Ail haché", measure: "4 gousses" },
          { name: "Huile de sésame", measure: "1 c. à soupe" },
          { name: "Bouillon de fruits de mer", measure: "500ml" },
          { name: "Oignons verts", measure: "2" },
          { name: "Courgette", measure: "1/2" },
        ],
        instructions:
          "1. Faire chauffer l'huile de sésame dans une casserole\n2. Faire revenir l'ail et flocons de piment\n3. Ajouter le bouillon et porter à ébullition\n4. Ajouter fruits de mer et courgette\n5. Cuire 3-4 minutes\n6. Ajouter délicatement le tofu soyeux en cubes\n7. Assaisonner avec sauce soja\n8. Faire un puits au centre et casser l'œuf\n9. Cuire 2-3 minutes sans toucher l'œuf\n10. Garnir d'oignons verts et servir bouillant",
      },
      {
        idMeal: "korean9",
        strMeal: "Galbi (Côtes de Bœuf Marinées)",
        strMealThumb:
          "https://images.unsplash.com/photo-1600891964092-4316c288032e?w=400",
        strArea: "Korean",
        strCategory: "Beef",
        description: "Côtes de bœuf marinées grillées au barbecue",
        ingredients: [
          { name: "Côtes de bœuf (galbi cut)", measure: "1.5kg" },
          { name: "Sauce soja", measure: "150ml" },
          { name: "Sucre brun", measure: "100g" },
          { name: "Poire asiatique", measure: "1 (mixée)" },
          { name: "Kiwi", measure: "1 (mixé)" },
          { name: "Oignon", measure: "1 (mixé)" },
          { name: "Ail haché", measure: "8 gousses" },
          { name: "Gingembre", measure: "2 c. à soupe" },
          { name: "Huile de sésame", measure: "3 c. à soupe" },
          { name: "Graines de sésame", measure: "2 c. à soupe" },
          { name: "Poivre noir", measure: "1 c. à thé" },
        ],
        instructions:
          "1. Entailler la viande pour meilleure pénétration marinade\n2. Mixer poire, kiwi et oignon (attendrisseurs)\n3. Mélanger sauce soja, sucre, ail, gingembre\n4. Ajouter le mélange fruits et huile de sésame\n5. Mariner les côtes minimum 4h (idéal : 24h)\n6. Préchauffer le grill à feu vif\n7. Griller les côtes 3-4 minutes chaque côté\n8. Badigeonner de marinade pendant cuisson\n9. Garnir de graines de sésame\n10. Servir avec laitue et ssam sauce",
      },
      {
        idMeal: "korean10",
        strMeal: "Jajangmyeon (Nouilles Sauce Noire)",
        strMealThumb:
          "https://images.unsplash.com/photo-1617093727343-374698b1b08d?w=400",
        strArea: "Korean",
        strCategory: "Noodles",
        description: "Nouilles épaisses sauce noire à la pâte de soja",
        ingredients: [
          { name: "Nouilles fraîches épaisses", measure: "400g" },
          {
            name: "Pâte de haricot noir (Chunjang)",
            measure: "4 c. à soupe",
          },
          { name: "Porc haché", measure: "300g" },
          { name: "Oignon", measure: "1 (en dés)" },
          { name: "Courgette", measure: "1 (en dés)" },
          { name: "Pomme de terre", measure: "1 (en dés)" },
          { name: "Chou", measure: "200g (coupé)" },
          { name: "Ail haché", measure: "4 gousses" },
          { name: "Sucre", measure: "2 c. à soupe" },
          { name: "Huile végétale", measure: "4 c. à soupe" },
          { name: "Fécule de maïs", measure: "2 c. à soupe (délayée)" },
        ],
        instructions:
          "1. Faire cuire les nouilles selon instructions\n2. Chauffer l'huile et faire caraméliser la pâte noire 2 min\n3. Retirer et réserver\n4. Faire revenir le porc haché jusqu'à doré\n5. Ajouter oignon, ail et légumes\n6. Faire sauter 5 minutes\n7. Ajouter la pâte noire, sucre et 300ml d'eau\n8. Mijoter 10 minutes\n9. Épaissir avec fécule de maïs diluée\n10. Servir la sauce noire sur les nouilles",
      },
      {
        idMeal: "korean11",
        strMeal: "Yukgaejang (Soupe de Bœuf Épicée)",
        strMealThumb:
          "https://images.unsplash.com/photo-1547592166-23ac45744acd?w=400",
        strArea: "Korean",
        strCategory: "Soup",
        description: "Soupe épicée au bœuf effiloché et légumes",
        ingredients: [
          { name: "Bœuf (poitrine)", measure: "500g" },
          { name: "Germes de soja", measure: "200g" },
          { name: "Fougères séchées", measure: "100g" },
          { name: "Oignons verts", measure: "5" },
          { name: "Ail haché", measure: "6 gousses" },
          { name: "Gochugaru (flocons piment)", measure: "4 c. à soupe" },
          { name: "Sauce soja", measure: "3 c. à soupe" },
          { name: "Huile de sésame", measure: "2 c. à soupe" },
          { name: "Œuf", measure: "1" },
          { name: "Bouillon de bœuf", measure: "2L" },
        ],
        instructions:
          "1. Faire bouillir le bœuf dans l'eau 1h jusqu'à tendre\n2. Effilocher la viande et réserver le bouillon\n3. Faire revenir bœuf avec ail et gochugaru\n4. Ajouter bouillon et porter à ébullition\n5. Ajouter germes de soja et fougères\n6. Assaisonner avec sauce soja et huile sésame\n7. Mijoter 20 minutes\n8. Ajouter oignons verts\n9. Casser un œuf et laisser pocher 2 min\n10. Servir bouillant très épicé",
      },
      {
        idMeal: "korean12",
        strMeal: "Dakgalbi (Poulet Épicé Sauté)",
        strMealThumb:
          "https://images.unsplash.com/photo-1598103442097-8b74394b95c6?w=400",
        strArea: "Korean",
        strCategory: "Chicken",
        description: "Poulet mariné piquant sauté avec légumes",
        ingredients: [
          { name: "Cuisses de poulet", measure: "600g (coupées)" },
          { name: "Gochujang", measure: "4 c. à soupe" },
          { name: "Gochugaru", measure: "2 c. à soupe" },
          { name: "Sauce soja", measure: "3 c. à soupe" },
          { name: "Sucre", measure: "2 c. à soupe" },
          { name: "Ail haché", measure: "5 gousses" },
          { name: "Chou", measure: "300g" },
          { name: "Patate douce", measure: "1 (tranches)" },
          { name: "Oignon", measure: "1" },
          { name: "Gâteaux de riz", measure: "150g" },
          { name: "Fromage mozzarella", measure: "100g (optionnel)" },
        ],
        instructions:
          "1. Mariner poulet : gochujang, gochugaru, sauce soja, sucre, ail (30 min)\n2. Chauffer une grande poêle ou plaque de grill\n3. Faire revenir le poulet mariné 5 minutes\n4. Ajouter chou, patate douce et oignon\n5. Faire sauter ensemble 10-12 minutes\n6. Ajouter gâteaux de riz en fin de cuisson\n7. Mélanger jusqu'à ce que tout soit bien cuit\n8. Optionnel : ajouter fromage sur les bords\n9. Servir directement de la poêle\n10. Manger avec riz blanc et kimchi",
      },
      {
        idMeal: "korean13",
        strMeal: "Haemul Pajeon (Crêpe Fruits de Mer)",
        strMealThumb:
          "https://images.unsplash.com/photo-1563379091339-03b847259519?w=400",
        strArea: "Korean",
        strCategory: "Seafood",
        description:
          "Crêpe coréenne épaisse aux fruits de mer et oignons verts",
        ingredients: [
          { name: "Farine", measure: "200g" },
          { name: "Eau froide", measure: "300ml" },
          { name: "Œuf", measure: "1" },
          { name: "Crevettes", measure: "150g" },
          { name: "Calamars", measure: "150g" },
          { name: "Palourdes", measure: "100g" },
          { name: "Oignons verts", measure: "6 (longs)" },
          { name: "Carotte", measure: "1/2 (julienne)" },
          { name: "Sel", measure: "1 c. à thé" },
          { name: "Huile végétale", measure: "6 c. à soupe" },
        ],
        instructions:
          "1. Mélanger farine, eau, œuf et sel pour faire la pâte\n2. Ajouter fruits de mer et oignons verts à la pâte\n3. Chauffer beaucoup d'huile dans une poêle\n4. Verser la moitié de la pâte en cercle\n5. Étaler bien à plat et cuire 4-5 minutes\n6. Retourner et cuire 4 minutes de l'autre côté\n7. Presser pour rendre croustillant\n8. Répéter avec le reste de pâte\n9. Couper en carrés\n10. Servir avec sauce soja-vinaigre",
      },
      {
        idMeal: "korean14",
        strMeal: "Kongbap (Riz aux Haricots)",
        strMealThumb:
          "https://images.unsplash.com/photo-1512058564366-18510be2db19?w=400",
        strArea: "Korean",
        strCategory: "Rice",
        description: "Riz mélangé avec plusieurs types de haricots",
        ingredients: [
          { name: "Riz blanc", measure: "2 tasses" },
          { name: "Haricots noirs", measure: "1/2 tasse" },
          { name: "Haricots rouges", measure: "1/2 tasse" },
          { name: "Haricots verts", measure: "1/2 tasse" },
          { name: "Orge", measure: "1/2 tasse" },
          { name: "Eau", measure: "3.5 tasses" },
          { name: "Sel", measure: "1 c. à thé" },
        ],
        instructions:
          "1. Faire tremper tous les haricots une nuit\n2. Rincer le riz et tous les haricots\n3. Mettre riz, haricots et orge dans un cuiseur\n4. Ajouter l'eau et le sel\n5. Cuire comme du riz normal\n6. Laisser reposer 10 minutes après cuisson\n7. Mélanger délicatement\n8. Servir avec kimchi et banchan",
      },
      {
        idMeal: "korean15",
        strMeal: "Bossam (Porc Bouilli Enveloppé)",
        strMealThumb:
          "https://images.unsplash.com/photo-1602030638412-bb8be5c2c544?w=400",
        strArea: "Korean",
        strCategory: "Pork",
        description: "Poitrine de porc bouillie servie avec kimchi et wraps",
        ingredients: [
          { name: "Poitrine de porc", measure: "1kg" },
          { name: "Oignon", measure: "1" },
          { name: "Ail entier", measure: "1 tête" },
          { name: "Gingembre", measure: "5cm" },
          { name: "Grains de poivre", measure: "1 c. à soupe" },
          { name: "Feuilles de laurier", measure: "3" },
          { name: "Laitue", measure: "1 tête" },
          { name: "Kimchi fermenté", measure: "300g" },
          { name: "Sauce ssamjang", measure: "150g" },
          { name: "Ail tranché", measure: "1 tête" },
        ],
        instructions:
          "1. Mettre le porc dans une grande casserole d'eau\n2. Ajouter oignon, ail, gingembre, poivre, laurier\n3. Porter à ébullition puis baisser à feu doux\n4. Mijoter 1h30 jusqu'à très tendre\n5. Retirer et laisser refroidir légèrement\n6. Trancher finement le porc\n7. Préparer les feuilles de laitue\n8. Servir avec kimchi frais et fermenté\n9. Envelopper : laitue + porc + kimchi + ssamjang + ail\n10. Déguster en une bouchée",
      },
      {
        idMeal: "korean16",
        strMeal: "Dolsot Bibimbap (Bibimbap en Pierre)",
        strMealThumb:
          "https://images.unsplash.com/photo-1553163147-622ab57be1c7?w=400",
        strArea: "Korean",
        strCategory: "Rice",
        description: "Bibimbap servi dans un bol en pierre chauffé",
        ingredients: [
          { name: "Riz blanc", measure: "4 tasses (cuit)" },
          { name: "Bœuf mariné", measure: "200g" },
          { name: "Épinards blanchis", measure: "150g" },
          { name: "Germes de soja", measure: "150g" },
          { name: "Carottes sautées", measure: "100g" },
          { name: "Champignons", measure: "100g" },
          { name: "Œufs", measure: "4" },
          { name: "Gochujang", measure: "4 c. à soupe" },
          { name: "Huile de sésame", measure: "4 c. à soupe" },
          { name: "Graines de sésame", measure: "2 c. à soupe" },
        ],
        instructions:
          "1. Préchauffer les bols en pierre (dolsot) 10 minutes\n2. Huiler généreusement les bols chauds\n3. Mettre le riz au fond de chaque bol\n4. Presser le riz contre les parois chaudes\n5. Disposer légumes et viande en sections\n6. Placer œuf au centre\n7. Laisser sur feu doux 3-4 minutes (croûte de riz)\n8. Ajouter gochujang et huile de sésame\n9. Mélanger vigoureusement avec cuillère\n10. Déguster avec la croûte de riz croustillante",
      },
      {
        idMeal: "korean17",
        strMeal: "Gamjatang (Soupe d'Échine de Porc)",
        strMealThumb:
          "https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=400",
        strArea: "Korean",
        strCategory: "Soup",
        description: "Soupe épicée avec échine de porc et pommes de terre",
        ingredients: [
          { name: "Échine de porc", measure: "1kg" },
          { name: "Pommes de terre", measure: "3 moyennes" },
          { name: "Feuilles de périlla", measure: "20" },
          { name: "Gochugaru", measure: "3 c. à soupe" },
          {
            name: "Pâte de soja fermentée (Doenjang)",
            measure: "2 c. à soupe",
          },
          { name: "Ail haché", measure: "8 gousses" },
          { name: "Gingembre", measure: "3cm" },
          { name: "Oignons verts", measure: "4" },
          { name: "Sauce soja", measure: "2 c. à soupe" },
          { name: "Huile de sésame", measure: "1 c. à soupe" },
        ],
        instructions:
          "1. Faire blanchir l'échine de porc 5 minutes\n2. Rincer et nettoyer la viande\n3. Faire bouillir dans 2L d'eau avec gingembre\n4. Mijoter 1h30 jusqu'à très tendre\n5. Ajouter pommes de terre en gros morceaux\n6. Assaisonner : gochugaru, doenjang, ail, sauce soja\n7. Cuire 20 minutes jusqu'à pommes de terre tendres\n8. Ajouter feuilles de périlla\n9. Ajouter oignons verts et huile de sésame\n10. Servir bouillant avec riz et kimchi",
      },
      {
        idMeal: "korean18",
        strMeal: "Naengmyeon (Nouilles Froides)",
        strMealThumb:
          "https://images.unsplash.com/photo-1617093727343-374698b1b08d?w=400",
        strArea: "Korean",
        strCategory: "Noodles",
        description: "Nouilles froides dans bouillon glacé (plat d'été)",
        ingredients: [
          { name: "Nouilles de sarrasin", measure: "400g" },
          { name: "Bouillon de bœuf", measure: "1L (refroidi)" },
          { name: "Vinaigre de riz", measure: "3 c. à soupe" },
          { name: "Sucre", measure: "1 c. à soupe" },
          { name: "Moutarde coréenne", measure: "1 c. à thé" },
          { name: "Bœuf bouilli", measure: "200g (tranché)" },
          { name: "Concombre", measure: "1 (julienne)" },
          { name: "Poire asiatique", measure: "1/2 (tranchée)" },
          { name: "Œuf dur", measure: "2 (coupés)" },
          { name: "Glaçons", measure: "Pour servir" },
        ],
        instructions:
          "1. Cuire les nouilles de sarrasin selon instructions\n2. Rincer abondamment à l'eau glacée\n3. Préparer le bouillon : refroidir complètement au frigo\n4. Assaisonner bouillon avec vinaigre, sucre, moutarde\n5. Dans des bols froids, mettre les nouilles\n6. Verser le bouillon glacé par-dessus\n7. Garnir de bœuf, concombre, poire\n8. Ajouter œuf dur et glaçons\n9. Servir immédiatement très froid\n10. Couper les nouilles avec ciseaux avant manger",
      },
      {
        idMeal: "korean19",
        strMeal: "Mandu (Raviolis Coréens)",
        strMealThumb:
          "https://images.unsplash.com/photo-1496116218417-1a781b1c416c?w=400",
        strArea: "Korean",
        strCategory: "Dumplings",
        description: "Raviolis farcis à la viande et légumes",
        ingredients: [
          { name: "Pâtes à raviolis", measure: "40 feuilles" },
          { name: "Porc haché", measure: "300g" },
          { name: "Tofu émietté", measure: "150g" },
          { name: "Chou kimchi", measure: "100g (haché)" },
          { name: "Germes de soja", measure: "100g (hachés)" },
          { name: "Oignons verts", measure: "3 (hachés)" },
          { name: "Ail haché", measure: "4 gousses" },
          { name: "Gingembre râpé", measure: "1 c. à thé" },
          { name: "Sauce soja", measure: "2 c. à soupe" },
          { name: "Huile de sésame", measure: "1 c. à soupe" },
        ],
        instructions:
          "1. Presser le tofu pour retirer l'eau\n2. Mélanger porc, tofu, kimchi, germes, oignons\n3. Assaisonner avec ail, gingembre, sauce soja, sésame\n4. Prendre une feuille de pâte\n5. Mettre 1 c. à soupe de farce au centre\n6. Humidifier les bords et plier en demi-lune\n7. Bien sceller les bords\n8. Cuire à la vapeur 10-12 minutes OU\n9. Faire frire jusqu'à dorés OU\n10. Faire bouillir dans soupe",
      },
      {
        idMeal: "korean20",
        strMeal: "Doenjang Jjigae (Ragoût Soja)",
        strMealThumb:
          "https://images.unsplash.com/photo-1547592166-23ac45744acd?w=400",
        strArea: "Korean",
        strCategory: "Soup",
        description: "Ragoût traditionnel à la pâte de soja fermentée",
        ingredients: [
          { name: "Pâte de soja (Doenjang)", measure: "3 c. à soupe" },
          { name: "Tofu", measure: "200g" },
          { name: "Courgette", measure: "1" },
          { name: "Pomme de terre", measure: "1" },
          { name: "Champignons", measure: "100g" },
          { name: "Oignon", measure: "1/2" },
          { name: "Piment vert", measure: "2" },
          { name: "Ail haché", measure: "3 gousses" },
          { name: "Bouillon d'anchois", measure: "600ml" },
          { name: "Oignons verts", measure: "2" },
        ],
        instructions:
          "1. Faire bouillir le bouillon d'anchois\n2. Dissoudre la pâte doenjang dans le bouillon\n3. Ajouter pomme de terre en cubes\n4. Cuire 10 minutes\n5. Ajouter courgette, champignons, oignon\n6. Cuire 5 minutes\n7. Ajouter tofu en cubes et piments\n8. Cuire 3 minutes\n9. Ajouter ail et oignons verts\n10. Servir bouillant avec riz",
      },
      {
        idMeal: "korean21",
        strMeal: "Kimchi Bokkeumbap (Riz Frit Kimchi)",
        strMealThumb:
          "https://images.unsplash.com/photo-1512058564366-18510be2db19?w=400",
        strArea: "Korean",
        strCategory: "Rice",
        description: "Riz frit avec kimchi vieilli et porc",
        ingredients: [
          { name: "Riz cuit (de la veille)", measure: "4 tasses" },
          { name: "Kimchi vieilli", measure: "300g (haché)" },
          { name: "Porc haché", measure: "200g" },
          { name: "Jus de kimchi", measure: "4 c. à soupe" },
          { name: "Gochugaru", measure: "1 c. à soupe" },
          { name: "Sauce soja", measure: "2 c. à soupe" },
          { name: "Sucre", measure: "1 c. à thé" },
          { name: "Huile de sésame", measure: "2 c. à soupe" },
          { name: "Oignons verts", measure: "3" },
          { name: "Œufs", measure: "4 (pour frire)" },
          { name: "Algue nori", measure: "2 feuilles (émietté)" },
        ],
        instructions:
          "1. Faire revenir le porc jusqu'à doré\n2. Ajouter kimchi haché et faire sauter 3 minutes\n3. Ajouter le riz froid et casser les grumeaux\n4. Ajouter jus de kimchi, gochugaru, sauce soja, sucre\n5. Faire sauter à feu vif 5-7 minutes\n6. Ajouter oignons verts et huile de sésame\n7. Faire des œufs au plat séparément\n8. Servir le riz dans des bols\n9. Poser œuf au plat sur chaque bol\n10. Garnir de nori émietté et graines de sésame",
      },
      {
        idMeal: "korean22",
        strMeal: "Kimbap (Rouleaux de Riz)",
        strMealThumb:
          "https://images.unsplash.com/photo-1553621042-f6e147245754?w=400",
        strArea: "Korean",
        strCategory: "Rice",
        description: "Rouleaux de riz coréens avec légumes et viande",
        ingredients: [
          { name: "Riz blanc", measure: "3 tasses (cuit)" },
          { name: "Feuilles de nori", measure: "6" },
          { name: "Œufs", measure: "3 (omelette)" },
          { name: "Carottes", measure: "2 (julienne)" },
          { name: "Concombre", measure: "1 (julienne)" },
          { name: "Épinards blanchis", measure: "150g" },
          { name: "Jambon ou bulgogi", measure: "200g" },
          { name: "Radis jaune mariné", measure: "100g" },
          { name: "Huile de sésame", measure: "3 c. à soupe" },
          { name: "Sel", measure: "1 c. à thé" },
          { name: "Graines de sésame", measure: "2 c. à soupe" },
        ],
        instructions:
          "1. Assaisonner le riz chaud : huile sésame, sel, graines sésame\n2. Préparer omelette fine et couper en lanières\n3. Faire sauter carottes légèrement\n4. Préparer tous les ingrédients en lanières\n5. Placer feuille de nori sur un tapis de bambou\n6. Étaler riz uniformément (laisser 2cm en haut)\n7. Disposer tous les ingrédients en ligne au centre\n8. Rouler fermement avec le tapis\n9. Sceller avec un peu d'eau\n10. Couper en tranches de 2cm avec couteau huilé",
      },
      {
        idMeal: "korean23",
        strMeal: "Jjamppong (Soupe Nouilles Fruits de Mer)",
        strMealThumb:
          "https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=400",
        strArea: "Korean",
        strCategory: "Noodles",
        description: "Soupe épicée rouge aux nouilles et fruits de mer",
        ingredients: [
          { name: "Nouilles fraîches", measure: "400g" },
          { name: "Crevettes", measure: "200g" },
          { name: "Calamars", measure: "200g" },
          { name: "Moules", measure: "150g" },
          { name: "Chou", measure: "200g" },
          { name: "Oignon", measure: "1" },
          { name: "Gochugaru", measure: "4 c. à soupe" },
          { name: "Ail haché", measure: "6 gousses" },
          { name: "Gingembre", measure: "2cm" },
          { name: "Bouillon de fruits de mer", measure: "1.5L" },
          { name: "Huile de sésame", measure: "2 c. à soupe" },
        ],
        instructions:
          "1. Faire revenir ail et gingembre dans huile\n2. Ajouter gochugaru et faire sauter 1 minute\n3. Ajouter fruits de mer et faire revenir\n4. Ajouter chou et oignon\n5. Verser le bouillon et porter à ébullition\n6. Cuire 10 minutes\n7. Faire cuire nouilles séparément\n8. Égoutter et ajouter aux fruits de mer\n9. Ajuster assaisonnement\n10. Servir bouillant très épicé",
      },
      {
        idMeal: "korean24",
        strMeal: "Dakdoritang (Ragoût de Poulet Épicé)",
        strMealThumb:
          "https://images.unsplash.com/photo-1598103442097-8b74394b95c6?w=400",
        strArea: "Korean",
        strCategory: "Chicken",
        description: "Ragoût de poulet mijoté sauce rouge piquante",
        ingredients: [
          { name: "Poulet (morceaux)", measure: "1kg" },
          { name: "Pommes de terre", measure: "3" },
          { name: "Carottes", measure: "2" },
          { name: "Oignon", measure: "1 gros" },
          { name: "Gochugaru", measure: "3 c. à soupe" },
          { name: "Gochujang", measure: "2 c. à soupe" },
          { name: "Sauce soja", measure: "4 c. à soupe" },
          { name: "Ail haché", measure: "6 gousses" },
          { name: "Gingembre", measure: "2cm" },
          { name: "Oignons verts", measure: "4" },
          { name: "Huile de sésame", measure: "1 c. à soupe" },
        ],
        instructions:
          "1. Couper poulet en morceaux moyens\n2. Mélanger gochugaru, gochujang, sauce soja, ail, gingembre\n3. Mariner le poulet 20 minutes\n4. Couper légumes en gros morceaux\n5. Faire revenir poulet mariné 5 minutes\n6. Ajouter pommes de terre et carottes\n7. Ajouter eau jusqu'à couvrir\n8. Mijoter 30-40 minutes\n9. Ajouter oignon et oignons verts\n10. Finir avec huile de sésame",
      },
      {
        idMeal: "korean25",
        strMeal: "Hotteok (Crêpes Sucrées)",
        strMealThumb:
          "https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=400",
        strArea: "Korean",
        strCategory: "Dessert",
        description: "Crêpes sucrées fourrées au sucre brun et noix",
        ingredients: [
          { name: "Farine", measure: "2 tasses" },
          { name: "Eau tiède", measure: "1 tasse" },
          { name: "Levure sèche", measure: "1 c. à thé" },
          { name: "Sucre blanc", measure: "2 c. à soupe" },
          { name: "Sel", measure: "1/2 c. à thé" },
          { name: "Sucre brun", measure: "150g" },
          { name: "Cannelle", measure: "1 c. à thé" },
          { name: "Noix hachées", measure: "100g" },
          { name: "Huile végétale", measure: "Pour frire" },
        ],
        instructions:
          "1. Mélanger farine, levure, sucre blanc, sel\n2. Ajouter eau tiède et pétrir 5 minutes\n3. Laisser lever 1 heure (doubler de volume)\n4. Mélanger sucre brun, cannelle et noix pour la garniture\n5. Diviser pâte en 8 boules\n6. Aplatir chaque boule\n7. Mettre 1 c. à soupe de garniture au centre\n8. Refermer et sceller\n9. Frire dans huile chaude\n10. Aplatir avec spatule en cuisant\n11. Cuire jusqu'à doré des deux côtés\n12. Servir chaud - le sucre fond à l'intérieur!",
      },
    ],
  },
  {
    name: "Sea Food",
    flag: "🦐",
    keywords: [
      "seafood boil",
      "louisiana",
      "cajun",
      "americain",
      "crab",
      "shrimp",
      "lobster",
      "fish",
      "seafood",
      "salmon",
      "prawn",
      "tuna",
      "boil",
      "americaine",
    ],
    customRecipes: [
      {
        idMeal: "seafood1",
        strMeal: "Poke Bowl aux Fruits de Mer",
        strMealThumb:
          "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400",
        strArea: "Hawaiian",
        strCategory: "Seafood",
        description:
          "Bol hawaïen frais avec poisson cru mariné, riz et légumes croquants",
        ingredients: [
          { name: "Thon frais (sushi grade)", measure: "300g" },
          { name: "Saumon frais (sushi grade)", measure: "200g" },
          { name: "Riz à sushi", measure: "2 tasses (cuit)" },
          { name: "Avocat", measure: "2" },
          { name: "Edamame", measure: "150g" },
          { name: "Concombre", measure: "1" },
          { name: "Algue wakame", measure: "100g" },
          { name: "Sauce soja", measure: "3 c. à soupe" },
          { name: "Huile de sésame", measure: "2 c. à soupe" },
          { name: "Graines de sésame", measure: "2 c. à soupe" },
          { name: "Oignon vert", measure: "3 tiges" },
          { name: "Gingembre frais", measure: "1cm" },
        ],
        instructions:
          "1. Couper le thon et saumon en cubes de 2cm\n2. Mariner avec sauce soja, huile sésame, gingembre (15 min)\n3. Cuire le riz à sushi et laisser refroidir\n4. Couper l'avocat, concombre en tranches\n5. Dans un bol, mettre le riz comme base\n6. Disposer le poisson mariné sur une moitié\n7. Arranger avocat, edamame, concombre, wakame\n8. Garnir de graines de sésame et oignon vert\n9. Servir frais avec sauce soja à côté",
      },
      {
        idMeal: "seafood2",
        strMeal: "Buddha Bowl Crevettes Grillées",
        strMealThumb:
          "https://images.unsplash.com/photo-1512058564366-18510be2db19?w=400",
        strArea: "International",
        strCategory: "Seafood",
        description:
          "Bol équilibré avec crevettes grillées, quinoa et légumes arc-en-ciel",
        ingredients: [
          { name: "Crevettes décortiquées", measure: "400g" },
          { name: "Quinoa", measure: "1 tasse (cuit)" },
          { name: "Patate douce", measure: "1 grande" },
          { name: "Brocoli", measure: "200g" },
          { name: "Avocat", measure: "1" },
          { name: "Chou rouge", measure: "100g (râpé)" },
          { name: "Pois chiches rôtis", measure: "150g" },
          { name: "Citron", measure: "2" },
          { name: "Ail", measure: "3 gousses" },
          { name: "Paprika fumé", measure: "1 c. à thé" },
          { name: "Huile d'olive", measure: "4 c. à soupe" },
          { name: "Tahini", measure: "3 c. à soupe" },
        ],
        instructions:
          "1. Cuire la patate douce au four (200°C, 25 min)\n2. Cuire le quinoa selon instructions\n3. Blanchir le brocoli 3 minutes\n4. Mariner crevettes : ail, paprika, citron, huile (10 min)\n5. Griller les crevettes 2-3 min de chaque côté\n6. Préparer sauce tahini : tahini + jus citron + eau\n7. Dans un bol, disposer quinoa comme base\n8. Arranger tous les légumes par sections\n9. Ajouter les crevettes grillées au centre\n10. Arroser de sauce tahini et servir",
      },
      {
        idMeal: "seafood3",
        strMeal: "Sea Food Bowl Asiatique",
        strMealThumb:
          "https://images.unsplash.com/photo-1617093727343-374698b1b08d?w=400",
        strArea: "Asian",
        strCategory: "Seafood",
        description:
          "Bol de nouilles aux fruits de mer variés dans un bouillon parfumé",
        ingredients: [
          { name: "Nouilles de riz", measure: "300g" },
          { name: "Crevettes", measure: "200g" },
          { name: "Calamars", measure: "150g" },
          { name: "Moules", measure: "200g" },
          { name: "Bouillon de poisson", measure: "1L" },
          { name: "Lait de coco", measure: "200ml" },
          { name: "Citronnelle", measure: "2 tiges" },
          { name: "Gingembre", measure: "3cm" },
          { name: "Ail", measure: "4 gousses" },
          { name: "Piment rouge", measure: "2" },
          { name: "Coriandre fraîche", measure: "1 bouquet" },
          { name: "Citron vert", measure: "2" },
        ],
        instructions:
          "1. Faire bouillir bouillon avec citronnelle et gingembre\n2. Ajouter lait de coco et mijoter 10 min\n3. Cuire les nouilles selon instructions\n4. Ajouter les fruits de mer dans le bouillon\n5. Cuire 5-7 minutes jusqu'à cuisson complète\n6. Dans des bols, mettre les nouilles\n7. Verser le bouillon aux fruits de mer\n8. Garnir de coriandre, piment, citron vert\n9. Servir très chaud et parfumé",
      },
      {
        idMeal: "seafood4",
        strMeal: "Saumon Bowl Teriyaki",
        strMealThumb:
          "https://images.unsplash.com/photo-1580959375944-0be94b1a2b61?w=400",
        strArea: "Japanese",
        strCategory: "Seafood",
        description:
          "Bol japonais avec saumon teriyaki, riz et légumes croquants",
        ingredients: [
          { name: "Filet de saumon", measure: "400g" },
          { name: "Riz japonais", measure: "2 tasses (cuit)" },
          { name: "Sauce teriyaki", measure: "100ml" },
          { name: "Brocoli", measure: "200g" },
          { name: "Carottes", measure: "2 (julienne)" },
          { name: "Edamame", measure: "150g" },
          { name: "Graines de sésame", measure: "2 c. à soupe" },
          { name: "Oignon vert", measure: "3 tiges" },
          { name: "Gingembre mariné", measure: "50g" },
          { name: "Nori", measure: "2 feuilles" },
        ],
        instructions:
          "1. Mariner le saumon dans la sauce teriyaki (20 min)\n2. Cuire le riz japonais\n3. Faire griller le saumon au four (180°C, 15 min)\n4. Faire sauter le brocoli et carottes légèrement\n5. Cuire les edamame 5 minutes\n6. Dans des bols, disposer le riz\n7. Arranger légumes et edamame\n8. Placer le saumon teriyaki au centre\n9. Garnir de sésame, oignon vert et nori\n10. Servir avec gingembre mariné",
      },
      {
        idMeal: "seafood5",
        strMeal: "Mediterranean Seafood Bowl",
        strMealThumb:
          "https://images.unsplash.com/photo-1559847844-5315695dadae?w=400",
        strArea: "Mediterranean",
        strCategory: "Seafood",
        description:
          "Bol méditerranéen avec fruits de mer grillés et légumes du soleil",
        ingredients: [
          { name: "Crevettes", measure: "200g" },
          { name: "Calamars", measure: "200g" },
          { name: "Couscous perlé", measure: "1 tasse (cuit)" },
          { name: "Tomates cerises", measure: "200g" },
          { name: "Concombre", measure: "1" },
          { name: "Olives noires", measure: "100g" },
          { name: "Feta", measure: "150g" },
          { name: "Citron", measure: "2" },
          { name: "Huile d'olive", measure: "4 c. à soupe" },
          { name: "Origan", measure: "2 c. à thé" },
          { name: "Ail", measure: "3 gousses" },
          { name: "Persil frais", measure: "1 bouquet" },
        ],
        instructions:
          "1. Mariner fruits de mer : huile, citron, ail, origan (15 min)\n2. Cuire le couscous perlé\n3. Griller crevettes et calamars 3-4 min de chaque côté\n4. Couper tomates cerises en deux\n5. Couper concombre en dés\n6. Dans des bols, mettre le couscous\n7. Arranger tomates, concombre, olives\n8. Ajouter les fruits de mer grillés\n9. Émietter la feta par-dessus\n10. Arroser d'huile d'olive et citron\n11. Garnir de persil frais",
      },
      {
        idMeal: "seafood6",
        strMeal: "Seafood Boil à l'Américaine",
        strMealThumb:
          "https://images.unsplash.com/photo-1626200419199-391ae4be7a41?w=400",
        strArea: "American",
        strCategory: "Seafood",
        description:
          "Le célèbre seafood boil cajun de Louisiane - fruits de mer et crustacés bouillis puis enrobés d'une sauce au beurre épicée. Plat convivial à manger avec les mains!",
        ingredients: [
          {
            name: "Crustacés au choix",
            measure: "Homards, crabes, crevettes, écrevisses",
          },
          {
            name: "Fruits de mer au choix",
            measure: "Moules, Saint-Jacques, clams, coques",
          },
          { name: "Pommes de terre", measure: "8 (pas trop grosses)" },
          { name: "Épis de maïs", measure: "4 (coupés en deux)" },
          { name: "Oignons", measure: "2 (hachés)" },
          { name: "Citron", measure: "1 (coupé en 4)" },
          { name: "Paprika", measure: "6 c. à soupe" },
          { name: "Épices cajun", measure: "6 c. à soupe" },
          { name: "Ail en poudre", measure: "3 c. à soupe" },
          { name: "Persil séché", measure: "5 c. à soupe" },
          { name: "Maïzena", measure: "1 c. à soupe" },
          { name: "Beurre", measure: "250g" },
          { name: "Sel", measure: "Généreux" },
          { name: "Poivre", measure: "Généreux" },
          { name: "Piment", measure: "Facultatif" },
          { name: "Œufs durs", measure: "4 (facultatif)" },
        ],
        instructions:
          "🦞 SEAFOOD BOIL À L'AMÉRICAINE 🦞\n\nPRÉPARATION (15 min):\n1. Nettoyez les fruits de mer ou décongelez-les (10 min dans eau tiède)\n2. Préparez tous les ingrédients\n\nCUIRE LE BOUILLON (15 min):\n3. Dans une TRÈS GRANDE casserole, mettez beaucoup d'eau\n4. Ajoutez 4 c. à soupe de paprika et d'épices cajun\n5. Ajoutez la moitié de l'ail en poudre et 4 c. à soupe de persil séché\n6. Salez et poivrez GÉNÉREUSEMENT\n7. Ajoutez la moitié des oignons et le citron\n8. Faites bouillir 15 minutes\n\nCUIRE LES LÉGUMES:\n9. Ajoutez les pommes de terre et le maïs\n10. Laissez cuire jusqu'à ce que les pommes de terre soient tendres\n11. Ôtez de la casserole et réservez\n\nCUIRE LES FRUITS DE MER (TRÈS RAPIDE!):\n12. Plongez les fruits de mer et crustacés dans le bouillon\n13. Laissez cuire juste quelques instants\n14. Dès que les crevettes sont roses, elles sont cuites!\n15. Saint-Jacques: pas plus d'1 minute\n16. Ôtez au fur et à mesure de leur cuisson avec une écumoire\n\nPRÉPARER LA SAUCE MAGIQUE:\n17. Dans une autre casserole, faites fondre le beurre (250g)\n18. Ajoutez l'oignon restant et les épices restantes\n19. Remuez et laissez cuire l'oignon\n20. Ajoutez 2-3 louches de bouillon\n21. Diluez la maïzena dans un peu d'eau\n22. Ajoutez à la sauce, mélangez jusqu'à épaississement\n\nSERVIR:\n23. Déposez fruits de mer, pommes de terre et maïs dans un grand plat\n24. Arrosez de la moitié de la sauce, mélangez bien\n25. Servez avec un bol de sauce à part pour tremper\n26. MANGER AVEC LES MAINS! C'est la tradition! 🦐🦀\n\n💡 CONSEILS:\n- Utilisez des fruits de mer surgelés, ça marche très bien!\n- La sauce est très grasse, c'est normal!\n- Parfait pour une fête entre amis!\n- Prévoyez des serviettes, ça va salir!",
      },
    ],
  },
  {
    name: "Brazilian",
    flag: "🇧🇷",
    keywords: ["feijoada", "brazilian", "beef", "beans"],
  },
  {
    name: "Argentinian",
    flag: "🇦🇷",
    keywords: ["empanada", "beef", "chimichurri"],
  },
];
